import { createFileRoute } from "@tanstack/react-router";
import { EnergizePage } from "../../pages/deposit/energize";

export const Route = createFileRoute("/incentive/energize")({
  component: RouteComponent,
});

function RouteComponent() {
  return <EnergizePage />;
}
